import React from "react";
import PropTypes from "prop-types";

import Firebase, { METHODS } from "../Utils/Firebase";

import VideoPlayer from "../Components/VideoPlayer.jsx";
import LoaderModule from "../Components/Loader.jsx";

const style = {
  marginTop: "150px",
  width: "90%",
  margin: "auto",
  author: {
    fontStyle: "italic"
  }
};

const Player = ({ videoId, user }) => (
  <div style={{marginTop: "100px"}}>
    <Firebase
      refPath={`/videos/${videoId}`}
      method={METHODS.ON}
      renderSuccess={(snapshot) => {
        const pitchInfo = snapshot.val();
        return (
          <div style={style}>
            <h1>{pitchInfo.title}</h1>
            <h3 style={style.author}>Par {pitchInfo.userName}</h3>
            <p>{pitchInfo.description}</p>
            <VideoPlayer
              src={pitchInfo.transcodedUrl}
              videoId={videoId}
              owner={pitchInfo.userId}
              user={user}
            />
          </div>
        );
      }}
      renderError={(error) => {
        return <pre>{JSON.stringify(error)}</pre>;
      }}
      renderPending={() => <LoaderModule />}
    />
  </div>
);

Player.propTypes = {
  videoId: PropTypes.string.isRequired
};

export default Player;
